import React from "react";
import toastr from "toastr";
import { Link } from "react-router-dom";

import { Constant } from "./Constant";
import { Validation } from "app/_helpers/validation/Validation";

import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import Prompt from "app/Components/IEnergyPrompt/Prompt";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

class AddDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      error: {},

      Department: "",

      submitted: false,
      changeRoute: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.setDepartment = this.setDepartment.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.dpId) {
      this.setDepartment(this.props.match.params.dpId);
    }
  }

  async setDepartment(id) {
    let response = await DepartmentService.getDepartmentByID(id);
    if (response && response.status && response?.data?.name) {
      this.setState(
        {
          Department: response.data.name,

          edit: true,
        },
        () => {}
      );
    } else {
      toastr.info("No Record Found");
      this.props.history.push("/");
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
        changeRoute: 1,
      },
      () => {
        this.checkValidation();
      }
    );
  };

  checkValidation() {
    if (this.state.submitted) {
      var errorObj = {};
      errorObj = Validation(this.state, Constant.Constants);
      this.setState({ error: errorObj, submitted: true });
    }
  }

  async onSubmit(e) {
    //  e.preventDefault();
    var errorObj = {};
    var flag = 0;

    errorObj = Validation(this.state, Constant.Constants);
    this.setState({ error: errorObj, submitted: true }, () => {});

    Object.keys(errorObj).forEach((index) => {
      if (errorObj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let obj = {
        name: this.state.Department,
      };

      let data = {};

      if (this.state.edit) {
        data = await DepartmentService.updateDepartment(
          this.props.match.params.dpId,
          obj
        );
      } else {
        data = await DepartmentService.createDepartment(obj);
      }

      if (data && data.status === 1) {
        this.setState({ changeRoute: "" });
        if (this.state.edit) {
          toastr.success("Department Updated Successfully");
          this.props.history.push("/user-management/department");
        } else {
          toastr.success("Department Created Successfully");
          this.props.history.push("/user-management/department");
        }
      } else if (data && data.message) {
        toastr.warning(data.message);
      }
    }
  }

  render() {
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Department", path: "/user-management/department" },
            { name: this.state.edit ? "Edit" : "Add" },
          ]}
          breadCrumbsText="User_Management_Department"
        />
        <Prompt changes={this.state.changeRoute}></Prompt>

        <div className="row d-flex justify-content-center">
          <div className="col-md-5">
            <div className="card mt-4 mb-3" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="simple-card-title">
                  <h3 class="text-capitalize mb-1">
                    {this.state.edit ? "Edit" : "Add"} Department
                  </h3>
                </div>

                <div className="row">
                  <div className="col-md-12 form-group mb-3">
                    <label>Department Name</label>
                    <input
                      type="text"
                      name="Department"
                      value={this.state.Department}
                      onChange={this.handleInputChange}
                      placeholder="Enter Department Name"
                      className="form-control"
                    />
                    {this.state.submitted &&
                      this.state.error.Department !== "" && (
                        <div className="fromerror">
                          {this.state.error.Department}
                        </div>
                      )}
                  </div>

                  <div className="col-md-12 text-center">
                    <Link
                      to="/user-management/department"
                      className="btn btn-secondary mr-2"
                    >
                      Back
                    </Link>
                    <button
                      className="btn btn-primary ml-2"
                      onClick={() => this.onSubmit()}
                    >
                      {this.state.edit ? "Update" : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddDepartment;
